<template lang="pug">
.padding
    .row
        .col-md-4
            .m-b-sm
                h5.m-b-0.p-t-sm._300 Import progress

        .col-md-12
            .box.padding.m-t-sm
                p Upload progress {{ rows  }} /  {{ uploaded }}
</template>

<script>
export default {
    data: () => ({
        uploaded: 0,
    }),

    computed: {
        url() {
            return Laroute.route('stocks.inventories.import_progress', {
                importkey: this.$route.params.key,
            });
        },

        rows() {
            return this.$route.params.rows;
        },
    },

    created() {
        this.pollingProgress();
    },

    methods: {
        async pollingProgress() {
            const retryCount = this.getRetryArray();

            const delayExecution = async () => {
                return new Promise(resolve => {
                    setTimeout(async () => {
                        resolve();
                    }, 3000);
                });
            };

            for (const retry of retryCount) {
                await delayExecution();

                const { data } = await axios.get(this.url);

                if (data.uploaded == this.$route.params.rows) {
                    this.uploaded += data.uploaded;

                    this.swal({
                        text: 'File upload processed',
                    });
                    this.$router.push(`/`);
                    break;
                }

                if (retry >= retryCount.length) {
                    throw new Error('Polling progress reached max limit');
                }
            }
        },

        getRetryArray(maxRetry = 150) {
            const retryCount = [];
            for (let i = 1; i <= maxRetry; i++) {
                retryCount.push(i);
            }

            return retryCount;
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/stock/stock-import-progress.vue